/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/main.scss"

const forceScrollTop = () => {
  if (typeof window === "undefined") return
  window.scrollTo(0, 0)
  if (document.documentElement) document.documentElement.scrollTop = 0
  if (document.body) document.body.scrollTop = 0
}

// Disable browser restoring a mid-page scroll after SPA navigations
if (typeof window !== "undefined" && window.history?.scrollRestoration) {
  window.history.scrollRestoration = "manual"
}

// Gatsby 5 + reach-router focus the page wrapper after navigation, which can
// leave a small residual scroll. Own scrolling and re-assert top after focus.
export const shouldUpdateScroll = ({ routerProps }) => {
  if (routerProps?.location?.hash) {
    return true
  }

  if (typeof window !== "undefined") {
    window.history.scrollRestoration = "manual"
  }

  forceScrollTop()
  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      forceScrollTop()
    })
  }, 0)

  return false
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location?.hash) return
  if (prevLocation && location?.pathname === prevLocation?.pathname) return

  forceScrollTop()
  window.requestAnimationFrame(() => {
    forceScrollTop()
    window.requestAnimationFrame(forceScrollTop)
  })
  // Catch late focus / layout shifts from fixed nav + iframe
  window.setTimeout(forceScrollTop, 0)
  window.setTimeout(forceScrollTop, 50)
  window.setTimeout(forceScrollTop, 150)
}
